import { z } from 'zod'

export const AddressUnavailableSchema = z.object({
  errorResolutionType: z.literal('ADDRESS_UNAVAILABLE'),
})
